import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ChangeForgotPasswordComponent } from './authentication/change-forgot-password/change-forgot-password.component';
import { AuthLoginGuard } from './authentication/guards/auth-login.guard';
import { AuthGuard } from './authentication/guards/auth.guard';
import { ForgotPassGuard } from './authentication/guards/forgot-pass.guard';
import { LoginComponent } from './authentication/login/login.component';
import { NotFoundComponent } from './authentication/not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [AuthLoginGuard],
    component: LoginComponent
  },
  {
    path: 'resetPassword/:token',
    canActivate: [ForgotPassGuard],
    component: ChangeForgotPasswordComponent
  },
  {
    path: 'despacho',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
